import React from 'react'

type SVGProps = React.SVGProps<SVGSVGElement>

export function CircleCheckFull(props: SVGProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_246_1135)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666626 8.00033C0.666626 3.95024 3.94987 0.666992 7.99996 0.666992C12.05 0.666992 15.3333 3.95024 15.3333 8.00033C15.3333 12.0504 12.05 15.3337 7.99996 15.3337C3.94987 15.3337 0.666626 12.0504 0.666626 8.00033Z"
          fill={props.fill || '#2ABE75'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5404 5.3623C11.8008 5.62265 11.8008 6.04476 11.5404 6.30511L7.40235 10.6384C7.142 10.8988 6.71989 10.8988 6.45954 10.6384L4.45954 8.63845C4.19919 8.3781 4.19919 7.95599 4.45954 7.69564C4.71989 7.43529 5.142 7.43529 5.40235 7.69564L6.93095 9.22423L10.5976 5.3623C10.858 5.10196 11.2801 5.10196 11.5404 5.3623Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_246_1135">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
